import {Grid} from '@logistics-frontend/blocks'
import clsx from 'clsx'

import {classes} from './FormBlock.classes'
import type {Props} from './FormBlock.types'

export function FormBlock({children, className, style}: Props): React.ReactElement {
  return (
    <Grid className={clsx(classes.root, className)} style={style} container>
      <Grid xs={12} item>
        {children}
      </Grid>
    </Grid>
  )
}
